import React, { ReactNode } from 'react'
import styles from "../../styles/common.module.css"

interface Props {
  children: ReactNode;
  className?: string; 
}


const Canvas: React.FC<Props> = ({ children, className }) => {
  return (
    <div className={`${styles.canvas} ${className ?? ""}`}>
        {children}
    </div>
  )
}

export default Canvas
